export default "__VITE_ASSET__CdO2akGd__"